<template>
  <v-card class="server-login-card">
    <v-card-title>
      Log in to Edval Cloud
    </v-card-title>
    <v-layout row wrap>
      <v-flex xs12 v-for="target in safeTargets" :key="target.key" class="loginButtons">
        <cloud-login-target :value="target" :open-target="openTarget" @openTarget="setOpenTarget"/>
      </v-flex>
    </v-layout>
    <v-card v-if="prodTargets.length > 0" class="productionCard">
      <h4>Live data</h4>
      <p>Do not edit without permission from client</p>
      <v-layout row wrap>
        <v-flex xs12 v-for="target in prodTargets" :key="target.key" class="loginButtons">
          <cloud-login-target :value="target" :open-target="openTarget"
                              @openTarget="setOpenTarget"/>
        </v-flex>
      </v-layout>
    </v-card>
  </v-card>
</template>

<script>
  import CloudLoginTarget from './CloudLoginTarget';

  export default {
    components: { CloudLoginTarget },
    data() {
      return {
        servers: [],
        openTarget: null
      };
    },
    computed: {
      accessibleTargets() {
        return this.servers;
      },
      safeTargets() {
        return this.accessibleTargets.filter((t) => !t.production);
      },
      prodTargets() {
        return this.accessibleTargets.filter((t) => t.production);
      }
    },
    methods: {
      setOpenTarget(target) {
        this.openTarget = target;
      }
    },
    mounted() {
      this.$services.authenticator.get('/user/servers')
              .then((res) => {
                this.servers = res.data.data;
                localStorage.setItem('servers', JSON.stringify(this.servers));
              })
              .catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style lang="less" scoped>
  @import "../../style/variables.less";

  .server-login-card {
    padding: 5px;

    .loginButtons:not(:last-child) {
      border-bottom: 1px solid lightgray;
    }
  }

  .productionCard {
    width: 100%;
    margin: 10px 0;

    h4 {
      text-align: left;
      padding: 15px;
      color: @edval-red;
    }

    p {
      text-align: left;
      margin: 8px 20px;
    }
  }
</style>
